import { ThemeColor } from "./theme-color";
import { resource, Entity } from 'aurelia-orm';


@resource('ItemTypeBase')
export class ItemTypeBase extends Entity {

	id: number;

	code: string;

    name: string;

    description: string;

    isActive: boolean;

    themeColorId: number;

    showAsColumn: boolean;

    sortOrder: number;

    get item() {
        return this;
    }
    
}